module.exports = __webpack_public_path__ + "img/fi-rr-location-alt.d5705a22.svg";